import React from 'react';
import { useHistory } from 'react-router-dom';
import { Flex, Modal, Text } from '@mantine/core';
import { ModalLogoutProps } from '.';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import Button from '../../elements/Button';
import { FiLogOut } from 'react-icons/fi';

const ModalLogout: React.FC<ModalLogoutProps> = ({ isOpen, onClose }) => {
  const history = useHistory();

  const handleLogout = () => {
    history.push('/logout');
  };

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      centered
      withCloseButton={false}
      closeOnClickOutside={false}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3
      }}
      padding={36}
      radius={16}
      size="lg"
    >
      <div className="wrapper-dialog-logout">
        <h2 className='m-0'>Logout dashboard</h2>

        <div className="wrapper-dialog-logout__content">
          <p className='m-0'>are you sure want to logout?</p>
          <div className="wrapper-dialog-logout__content__actions">
            <div>
              <Button variant="error-beelajar" full onClick={() => onClose()}>
                <Flex align={'center'} justify={"center"}>
                  <Text>Go Back</Text>
                </Flex>
              </Button>
            </div>
            <div>
              <Button variant="error" full onClick={() => handleLogout()}>
                <div>
                  <FiLogOut />
                  Logout
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalLogout;
